export const kakaoSdkKey = '8176503f7cd2ef2f851a683b5d44a9ef'
